var moduleMap = {
	"./routes": () => {
		return Promise.all(/* __federation_expose_routes */[__webpack_require__.e(96), __webpack_require__.e(642), __webpack_require__.e(155), __webpack_require__.e(806)]).then(() => (() => ((__webpack_require__(3444)))));
	},
	"./handlers": () => {
		return Promise.all(/* __federation_expose_handlers */[__webpack_require__.e(96), __webpack_require__.e(210), __webpack_require__.e(943)]).then(() => (() => ((__webpack_require__(712)))));
	},
	"./layout-wrapper": () => {
		return Promise.all(/* __federation_expose_layout_wrapper */[__webpack_require__.e(96), __webpack_require__.e(642), __webpack_require__.e(858), __webpack_require__.e(155), __webpack_require__.e(238), __webpack_require__.e(558)]).then(() => (() => ((__webpack_require__(9102)))));
	},
	"./dashboard-invoice-overview": () => {
		return Promise.all(/* __federation_expose_dashboard_invoice_overview */[__webpack_require__.e(96), __webpack_require__.e(642), __webpack_require__.e(858), __webpack_require__.e(978)]).then(() => (() => ((__webpack_require__(3876)))));
	},
	"./contribution-table": () => {
		return Promise.all(/* __federation_expose_contribution_table */[__webpack_require__.e(96), __webpack_require__.e(642), __webpack_require__.e(858), __webpack_require__.e(155), __webpack_require__.e(238), __webpack_require__.e(299)]).then(() => (() => ((__webpack_require__(535)))));
	}
};
var get = (module, getScope) => {
	__webpack_require__.R = getScope;
	getScope = (
		__webpack_require__.o(moduleMap, module)
			? moduleMap[module]()
			: Promise.resolve().then(() => {
				throw new Error('Module "' + module + '" does not exist in container.');
			})
	);
	__webpack_require__.R = undefined;
	return getScope;
};
var init = (shareScope, initScope, remoteEntryInitOptions) => {
	return __webpack_require__.federation.bundlerRuntime.initContainerEntry({	webpackRequire: __webpack_require__,
		shareScope: shareScope,
		initScope: initScope,
		remoteEntryInitOptions: remoteEntryInitOptions,
		shareScopeKey: "default"
	})
};
// This exports getters to disallow modifications
__webpack_require__.d(exports, {
	get: () => (get),
	init: () => (init)
});